import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import AuthEffectComponent from "./Auth/AuthEffectComponent";
import * as Actions from "./flex/Actions";
import Map from "./components/map/Map";

export default function App() {
    const dispatch = useDispatch();
    //Sessionページが必要かどうかをここで判断してよしなに処理
    if (process.env.REACT_APP_HAVE_SESSION === "true") {
        //FIXME 本来はログインチェックを行うためのAPIを別途用意しておくべき
        dispatch(Actions.http.connection.authentication.login())
    }

    return (
        <Router basename={process.env.PUBLIC_URL}>
                <Switch >
                    <Route path="/">
                        <PublicPage/>
                    </Route>
                    <PrivateRoute>
                        <ProtectedPage/>
                    </PrivateRoute>
                </Switch>
                <AuthEffectComponent/>
        </Router>
    );
}

function PrivateRoute({children, ...rest}) {
    const session = useSelector(state => state.session);
    const loginConnection = useSelector(state => state.loginConnection);

    return (
        loginConnection.meta.fetch || !session.payload.is_checked ?
            <div>private fetch or is_checked</div>
            :
            <Route
                {...rest}
                render={({location}) =>
                    session.payload.is_authenticated ? (
                        children
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/",
                                state: {from: location}
                            }}
                        />
                    )
                }
            />
    );
}

//未認証時のページ
function PublicPage({children, ...rest}) {
    const session = useSelector(state => state.session);
    const loginConnection = useSelector(state => state.loginConnection);

    return (
        loginConnection.meta.fetch || !session.payload.is_checked ?
            <div>public fetch or is_checked</div>
            :
            <Route
                {...rest}
                render={({location}) =>
                    session.payload.is_authenticated ? (
                        <Redirect
                            to={{
                                pathname: "/",
                                state: {from: location}
                            }}
                        />
                    ) : (
                        <Map/>
                    )
                }
            />
    );
}

//認証時のページ
function ProtectedPage() {
    return <h3>Protected</h3>;
}

